import React, {Component} from 'react';
import {Grid, Dropdown, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {colors} from '../../../../common/constants/colors';
import BarChart from './chart/bar';
import LineChart from './chart/line';
import PieChart from './chart/pie';
import './chartSection.scss';

const typesOfGraphics = [
  {'name': 'Pastel', 'value': 'pie'},
  {'name': 'Líneas', 'value': 'line'},
  {'name': 'Barras', 'value': 'bar'},
];

class ChartSectionInSalesByAgencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'typeOfGraphicTmp': typesOfGraphics[0].value,
      'typeOfGraphicSelected': typesOfGraphics[0].value,
      'data': props.data,
      'dictionaryAgenciesNames': {},
    };
  }

  componentDidMount() {
    const {data} = this.props;
    const dictionary = {};

    data.forEach((element) => {
      dictionary[element.code] = element.name;
    });
    this.setState({'dictionaryAgenciesNames': dictionary});
  }

  getTypesOfGraphics() {
    return typesOfGraphics.map((element) => {
      return {'text': element.name, 'value': element.value};
    });
  }

  changeTypeOfGraphic(value) {
    this.setState({'typeOfGraphicTmp': value}, () =>
      this.updateDataForTypeOfGraphic()
    );
  }

  updateDataForTypeOfGraphic() {
    const {typeOfGraphicSelected, typeOfGraphicTmp} = this.state;
    if (typeOfGraphicSelected === typeOfGraphicTmp) {
      return;
    }
    this.setState({
      'typeOfGraphicSelected': typeOfGraphicTmp,
    });
  }

  setCheckedData() {
    const {data, dictionaryAgenciesNames, typeOfGraphicSelected} = this.state;
    return data.map((element, index) => {
      const divStyle = {
        'color': typeOfGraphicSelected === 'line' ? colors[0] : element.color,
      };
      const disabledClass = element.showData ? '' : 'disabled';
      return (
        <div
          key={index}
          onClick={() => this.onShowSalesDataChange(element.code)}
          className={disabledClass}
        >
          <span style={divStyle}>
            <Icon name='stop' size={'big'} />
          </span>
          {dictionaryAgenciesNames[element.code]}
        </div>
      );
    });
  }

  onShowSalesDataChange(code) {
    const {data} = this.state;
    const index = _.findIndex(data, {code});
    const isShowData = data[index].showData;

    const newData = [...data];
    newData[index].showData = !isShowData;

    this.setState({'data': newData});
  }

  renderChartSection() {
    const {data} = this.props;
    const newData = _.filter(data, {'showData': true});

    if (!data || !data.length) {
      return (
        <div className='without-data'>No hay datos para generar el gráfico</div>
      );
    }
    const {typeOfGraphicSelected} = this.state;
    switch (typeOfGraphicSelected) {
      default:
      case 'bar':
        return <BarChart data={newData} />;
      case 'line':
        return <LineChart data={newData} />;
      case 'pie':
        return <PieChart data={newData} />;
    }
  }

  render() {
    const {title, type} = this.props;
    const {typeOfGraphicTmp} = this.state;
    return (
      <div className='chart-section title-bar'>
        <div className='title'>
          <h2>{title.toUpperCase()}</h2>
          <div className='title-bar-actions'>
            <h4>Tipo Gráfico</h4>
            <Dropdown
              selection
              options={this.getTypesOfGraphics()}
              search
              value={typeOfGraphicTmp}
              onChange={(e, {value}) => this.changeTypeOfGraphic(value)}
              placeholder='Tipo de gráfico'
            />
          </div>
        </div>
        <div className='filters-section'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={type === 'dealer' ? 16 : 3}>
                <div className='filters-section check-section'>
                  {this.setCheckedData()}
                </div>
              </Grid.Column>
              <Grid.Column width={type === 'dealer' ? 16 : 13}>
                {this.renderChartSection()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default ChartSectionInSalesByAgencies;
